import React from "react";
import {
  TrendingUp,
  TrendingDown,
} from "lucide-react";
import Icon from "../assets/icons";
import { Card, CardContent } from "./ui/card";


type StatCardProps = {
  title: string;
  value: string;
  change: {
    value: string;
    positive: boolean;
  };
  icon: React.ReactNode;
};

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  change,
  icon,
  
}) => {
  return (
    <Card className="overflow-hidden transition-all duration-300 hover:shadow-md animate-fadeIn">
      <CardContent className="p-6">
        <div>
          <div className="flex justify-end">{icon}</div>

          <div className="flex justify-between items-start">
            <p className="text-sm font-medium text-gray-500">{title}</p>
            <h4 className="text-[36px] font-extrabold mt-1">{value}</h4>
            <div
              className={`flex items-center mt-1 text-sm ${
                change.positive ? "text-green-600" : "text-red-600"
              }`}
            >
              {change.positive ? (
                <TrendingUp className="w-4 h-4 mr-1" />
              ) : (
                <TrendingDown className="w-4 h-4 mr-1" />
              )}
              <span>{change.value}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const DashboardStats: React.FC = () => {
  const stats = [
    {
      title: "Total Revenue",
      value: "3.62M",
      change: { value: "+12% vs yesterday", positive: true },
      icon: <Icon name="currencyIcon" />,
    },
    {
      title: "Total Quantity",
      value: "1.35MT",
      change: { value: "+8% vs last week", positive: true },
      icon: <Icon name="quantityIcon" />,
    },
    {
      title: "Total Order",
      value: "24",
      change: { value: "+3 since yesterday", positive: false },
      icon: <Icon name="orderIcon" />,
    },
    {
      title: "New Customers",
      value: "42",
      change: { value: "-7% vs yesterday", positive: true },
      icon: <Icon name="customerIcon" />,
      color: "bg-purple-500",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {stats.map((stat, index) => (
        <StatCard
          key={index}
          title={stat.title}
          value={stat.value}
          change={stat.change}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};

export default DashboardStats;
